import { MantineSize } from '@mantine/core';
import classNames from 'classnames';

interface ProgressStepsProps {
  count: number;
  activeStep: number;
  className?: string;
  size?: MantineSize;
}

const SM = 'w-[20px]';
const MD = 'w-[40px]';
const LG = 'w-[60px]';

const SIZE_TO_STYLE: Record<MantineSize, string> = {
  xs: 'w-[10px]',
  sm: 'w-[20px]',
  md: 'w-[40px]',
  lg: 'w-[60px]',
  xl: 'w-[80px]',
};

export const ProgressSteps = ({
  count,
  activeStep,
  className,
  size = 'md',
}: ProgressStepsProps) => {
  return (
    <div
      className={`flex items-center justify-center h-[10px] py-2 ${className}`}
    >
      {[...Array(count)].map((_, idx) => (
        <span
          className={classNames(`mx-1 rounded h-[8px] ${SIZE_TO_STYLE[size]}`, {
            'bg-primary-700': activeStep === idx,
            'bg-primary-400': activeStep !== idx,
          })}
        />
      ))}
    </div>
  );
};
